"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortTargetFiles = sortTargetFiles;
exports.getWorkspacesMap = getWorkspacesMap;
exports.packageJsonBelongsToWorkspace = packageJsonBelongsToWorkspace;
const debugModule = require("debug");
const pathUtil = require("path");
const lockFileParser = require("snyk-nodejs-lockfile-parser");
const micromatch = require("micromatch");
const lodash_1 = require("lodash");
const utils_1 = require("../utils");
const debug = debugModule('snyk-workspaces');
function sortTargetFiles(targetFiles, rootFiles) {
    // the order of targetFiles folders is important
    // must have the root level most folders at the top
    const mappedAndFiltered = targetFiles
        .map((p) => ({ path: p, ...pathUtil.parse(p) }))
        .filter((res) => rootFiles.includes(res.base));
    const sorted = (0, lodash_1.sortBy)(mappedAndFiltered, 'dir');
    const groupedTargetFiles = (0, lodash_1.groupBy)(sorted, 'dir');
    return groupedTargetFiles;
}
function getWorkspacesMap(root, directory, packageJson) {
    const pnpmWorkspacesMap = {};
    const pnpmWorkspacesPath = pathUtil.join(directory, 'pnpm-workspace.yaml');
    if (!(0, utils_1.fileExists)(root, pnpmWorkspacesPath)) {
        return pnpmWorkspacesMap;
    }
    const file = (0, utils_1.getFileContents)(root, pnpmWorkspacesPath);
    if (!file) {
        return pnpmWorkspacesMap;
    }
    try {
        const rootFileWorkspacesDefinitions = lockFileParser.getPnpmWorkspaces(file.content);
        if (rootFileWorkspacesDefinitions && rootFileWorkspacesDefinitions.length) {
            pnpmWorkspacesMap[packageJson.fileName] = {
                workspaces: rootFileWorkspacesDefinitions,
            };
        }
    }
    catch (e) {
        debug('Failed to process a workspace', e.message);
    }
    return pnpmWorkspacesMap;
}
function packageJsonBelongsToWorkspace(packageJsonFileName, pnpmWorkspacesMap, workspaceRoot) {
    const workspaceRootFolder = pathUtil.dirname((0, utils_1.normalizeFilePath)(workspaceRoot));
    const workspacesGlobs = (pnpmWorkspacesMap[workspaceRoot].workspaces || []).map((workspace) => pathUtil.join(workspaceRootFolder, workspace));
    const match = micromatch.isMatch((0, utils_1.normalizeFilePath)(packageJsonFileName), workspacesGlobs.map((p) => (0, utils_1.normalizeFilePath)(pathUtil.join(p, '**'))));
    return match;
}
//# sourceMappingURL=workspace-utils.js.map